import { Component } from '@angular/core';
import { AngularModule } from '../../../../../../modules/angular.module';

@Component({
	selector: 'app-white-panel',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './white-panel.component.html',
	styleUrl: './white-panel.component.scss',
})
export class WhitePanelComponent {}
